import React from "react"

export function ExternalLink({
  to,
  children,
  className,
  onClick,
  disabled,
  style,
}: {
  to: string
  children: React.ReactNode
  className?: string
  onClick?(): void
  disabled?: boolean
  style?: any
}) {
  return (
    <a
      href={disabled ? undefined : to}
      onClick={onClick}
      rel="noopener noreferrer"
      target="_blank"
      className={className}
      style={style}
    >
      {children}
    </a>
  )
}
